import { env } from '@goaltree/env/web'
import posthog from 'posthog-js'

if (env.VITE_POSTHOG_KEY && import.meta.env.PROD) {
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false, // TanStack Router handles navigation; we track manually
  })
}

export { posthog }
